var _defineProperty = require("/home/emil/thebiz/frontend/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var QRCode = require('qrcode-svg');

var urls = require('.');

module.exports = {
  bitcoin: wrap(urls.bitcoin),
  lightning: wrap(urls.lightning),
  ethereum: wrap(urls.ethereum)
};

function wrap(fn) {
  return function (coinOpts) {
    var qrOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var url = fn(coinOpts);
    return {
      qrcode: new QRCode(_objectSpread({
        content: url,
        width: 256,
        height: 256,
        ecl: 'L',
        join: true,
        pretty: false,
        xmlDeclaration: false,
        container: 'svg-viewbox',
        predefined: true
      }, qrOpts)).svg(),
      url: url
    };
  };
}